export const estates = [
    {
        "id" : "1",
        "tag" : "popular",
        "image_src" : "https://photos.zillowstatic.com/fp/1369a707583a5b9a956f8347ef81e12e-p_e.jpg",
        "price" : "$995",
        "title" : "Palm Harbor",
        "desc" : "2699 Green Valley, Highland Lake, FL",
        "beds" : "3",
        "bathrooms" : "2",
        "area" : "5x7",
        "type" : "house",
        "location" : "India",
        "price_range": "$500-$1000"
    },
    {
        "id" : "2",
        "tag" : "popular",
        "image_src" : "https://photos.zillowstatic.com/fp/f5fe7ae4a6186bdcb1de9dcb8e63c5d7-p_e.jpg",
        "price" : "$1700",
        "title" : "Beverly Hills",
        "desc" : "2821 Lane, Beverly Hills",
        "beds" : "4",
        "bathrooms" : "2",
        "area" : "5x6.2",
        "type" : "house",
        "location" : "India",
        "price_range": "$1000-$2000"
    },
    {
        "id" : "3",
        "image_src" : "https://photos.zillowstatic.com/fp/8287d19f41ceb9aa4b52c7b5da801b29-p_e.jpg",
        "price" : "$2800",
        "title" : "Faulkner Ave",
        "desc" : "2794, Green Park, Faulker Avenue",
        "beds" : "5",
        "bathrooms" : "3",
        "area" : "7x6.2",
        "type" : "flat",
        "location" : "India",
        "price_range": "$2000-$3000"
    },
    {
        "id" : "4",
        "image_src" : "https://photos.zillowstatic.com/fp/070a57df52d89f05034ddfbb760682bc-p_e.jpg",
        "price" : "$3500",
        "title" : "Yonkers",
        "desc" : "2387, Garden City, Clifton",
        "beds" : "4",
        "bathrooms" : "2",
        "area" : "5x2",
        "type" : "apartment",
        "location" : "India",
        "price_range": "$3000-$4000"
    },
    {
        "id" : "5",
        "image_src" : "https://photos.zillowstatic.com/fp/5703e008a82ab58dfff1e03017407185-p_e.jpg",
        "price" : "$4500",
        "title" : "New Rochelle",
        "desc" : "2487, Glen Cove, Westbury, Union State",
        "beds" : "5",
        "bathrooms" : "3",
        "area" : "5x4",
        "type" : "house",
        "tag" : "popular",
        "location" : "India",
        "price_range": "$4000-$5000"
    },
    {
        "id" : "6",
        "image_src" : "https://photos.zillowstatic.com/fp/e79699b6862cb571494fce61fa4e1678-p_e.jpg",
        "price" : "$5567",
        "title" : "Montclair",
        "desc" : "2230, Wayne, Near Long Beach",
        "beds" : "2",
        "bathrooms" : "1",
        "area" : "3x4",
        "type" : "flat",
        "tag" : "popular",
        "location" : "India",
        "price_range": "$5000-$6000"
    },
    {
        "id" : "7",
        "image_src" : "https://photos.zillowstatic.com/fp/3bb42d1cf57d45cadf8824f5a4372bf3-p_e.jpg",
        "price" : "$2309",
        "title" : "Sowae Corp",
        "desc" : "13424, 155th St, Jamaica, NY 1134",
        "beds" : "4",
        "bathrooms" : "2",
        "area" : "5x4",
        "type" : "house",
        "tag" : "popular",
        "location" : "India",
        "price_range": "$2000-$3000"
    },
    {
        "id" : "8",
        "image_src" : "https://photos.zillowstatic.com/fp/8b2553740fdda0af4b3c059ca31e8e7c-p_e.jpg",
        "price" : "$2349",
        "title" : "Berkshire",
        "desc" : "1259, Grant Avenue UNIT 5H, BRC",
        "beds" : "3",
        "bathrooms" : "2",
        "area" : "4x4",
        "type" : "apartment",
        "location" : "India",
        "price_range": "$2000-$3000"
    },
    {
        "id" : "9",
        "image_src" : "https://photos.zillowstatic.com/fp/03abbdb3bc27fbe575a6a0e9fe4945c5-p_e.jpg",
        "price" : "$2229",
        "title" : "Doughlas",
        "desc" : "1259, Grant Avenue UNIT 5H, BRC",
        "beds" : "2",
        "bathrooms" : "2",
        "area" : "4x4",
        "type" : "flat",
        "location" : "India",
        "price_range": "$2000-$3000"
    },
    {
        "id" : "10",
        "image_src" : "https://photos.zillowstatic.com/fp/fedc16a739ca2b9d59d567659a1eac70-p_e.jpg",
        "price" : "$1290",
        "title" : "Realty",
        "desc" : "69-06 197th St floor 1, Fresh Meadows",
        "beds" : "2",
        "bathrooms" : "2",
        "area" : "5x4",
        "type" : "apartment",
        "location" : "India",
        "price_range": "$1000-$2000"
    },
    {
        "id" : "11",
        "image_src" : "https://photos.zillowstatic.com/fp/afd810032ee74c90f59b125055442479-p_e.jpg",
        "price" : "$3490",
        "title" : "Compass",
        "desc" : "11610 155th St, Jamaica",
        "beds" : "4",
        "bathrooms" : "4",
        "area" : "7x4",
        "type" : "house",
        "tag": "popular",
        "location" : "Canada",
        "price_range": "$3000-$4000"
    },
    {
        "id" : "12",
        "image_src" : "https://photos.zillowstatic.com/fp/9892d6c7f4601145d8b5c421f01da8ab-p_e.jpg",
        "price" : "$3290",
        "title" : "Kings Village",
        "desc" : "1974, La Fontaine Ave #5C, Bronx, NY-10457",
        "beds" : "3",
        "bathrooms" : "3",
        "area" : "5x4",
        "type" : "flat",
        "tag": "popular",
        "location" : "Canada",
        "price_range": "$3000-$4000"
    },
    {
        "id" : "13",
        "image_src" : "https://photos.zillowstatic.com/fp/3163d23da0449d37aba1bc77d4bed417-p_e.jpg",
        "price" : "$4290",
        "title" : "Royale Voyage",
        "desc" : "118, Schenectady Ave APT 409, Brooklyn",
        "beds" : "6",
        "bathrooms" : "4",
        "area" : "12x3",
        "type" : "house",
        "tag": "popular",
        "location" : "Canada",
        "price_range": "$4000-$5000"
    },
    {
        "id" : "14",
        "image_src" : "https://photos.zillowstatic.com/fp/5b253c7b80f7253f3e4b21fd3ac0887a-p_e.jpg",
        "price" : "$990",
        "title" : "Countryside",
        "desc" : "2925 Mathews Ave APT 6j, Bronx",
        "beds" : "1",
        "bathrooms" : "1",
        "area" : "3x3",
        "type" : "flat",
        "location" : "Canada",
        "price_range": "$500-$1000"
    },
    {
        "id" : "15",
        "image_src" : "https://photos.zillowstatic.com/fp/5b253c7b80f7253f3e4b21fd3ac0887a-p_e.jpg",
        "price" : "$990",
        "title" : "Countryside",
        "desc" : "2925 Mathews Ave APT 6j, Bronx",
        "beds" : "1",
        "bathrooms" : "1",
        "area" : "3x3",
        "type" : "flat",
        "location" : "Canada",
        "price_range": "$500-$1000"
    },
    {
        "id" : "16",
        "image_src" : "https://photos.zillowstatic.com/fp/f802605124b90428355f747961c99371-p_e.jpg",
        "price" : "$5990",
        "title" : "Coldwell",
        "desc" : "100 W 57TH St unit 4jk",
        "beds" : "6",
        "bathrooms" : "4",
        "area" : "9x3",
        "type" : "apartment",
        "location" : "Canada",
        "price_range": "$5000-$6000"
    },
    {
        "id" : "17",
        "image_src" : "https://photos.zillowstatic.com/fp/49b2281452862ee87865d8fcac756c2c-p_e.jpg",
        "price" : "$870",
        "title" : "Corcoran",
        "desc" : "350 Putnam Ave, Brooklyn, 11216",
        "beds" : "1",
        "bathrooms" : "1",
        "area" : "2x3",
        "type" : "apartment",
        "tag" : "popular",
        "location" : "Canada",
        "price_range": "$500-$1000"
    },
    {
        "id" : "18",
        "image_src" : "https://photos.zillowstatic.com/fp/c4b4260df82ed51c53d8a57e43a75a27-p_e.jpg",
        "price" : "$800",
        "title" : "Aspire",
        "desc" : "3603 Broadway APT 3B, 10031",
        "beds" : "1",
        "bathrooms" : "1",
        "area" : "2x3",
        "type" : "apartment",
        "tag" : "popular",
        "location" : "Canada",
        "price_range": "$500-$1000"
    },
    {
        "id" : "19",
        "image_src" : "https://photos.zillowstatic.com/fp/ecc7db87ada9c99bbd4faff641f8d183-p_e.jpg",
        "price" : "$5400",
        "title" : "Royal Show",
        "desc" : "72 Richardson St #10, Brooklyn, 11211",
        "beds" : "4",
        "bathrooms" : "4",
        "area" : "9x3",
        "type" : "apartment",
        "location" : "Canada",
        "price_range": "$5000-$6000"
    },
    {
        "id" : "20",
        "image_src" : "https://photos.zillowstatic.com/fp/5740274c00eab1438ff69abf263105ef-p_e.jpg",
        "price" : "$850",
        "title" : "Doughlas",
        "desc" : "175-45 88th Avenue UNIT 7B, Jamaica",
        "beds" : "2",
        "bathrooms" : "1",
        "area" : "2x3",
        "type" : "apartment",
        "location" : "Canada",
        "price_range": "$500-$1000"
    },
    {
        "id" : "21",
        "image_src" : "https://photos.zillowstatic.com/fp/b7a14875ef4badf7eac178fda5810f40-p_e.jpg",
        "price" : "$5550",
        "title" : "O'Kane",
        "desc" : "15 Central Park W PENTHOUSE 41, New York",
        "beds" : "5",
        "bathrooms" : "4",
        "area" : "9x3",
        "type" : "apartment",
        "location" : "New York",
        "price_range": "$5000-$6000"
    },
    {
        "id" : "22",
        "image_src" : "https://photos.zillowstatic.com/fp/b7a14875ef4badf7eac178fda5810f40-p_e.jpg",
        "price" : "$750",
        "title" : "Remax City Square",
        "desc" : "21-16 35th St APT 1B, Astoria, NY-11105",
        "beds" : "2",
        "bathrooms" : "1",
        "area" : "2x3",
        "type" : "flat",
        "location" : "New York",
        "price_range": "$500-$1000"
    },
    {
        "id" : "23",
        "image_src" : "https://photos.zillowstatic.com/fp/e00c760e9e225346cd992c4ab2212d58-p_e.jpg",
        "price" : "$650",
        "title" : "Realty",
        "desc" : "61-35 98th Street UNIT STF, Rego Park, NY",
        "beds" : "1",
        "bathrooms" : "1",
        "area" : "2x3",
        "type" : "flat",
        "location" : "New York",
        "price_range": "$500-$1000"
    },
    {
        "id" : "24",
        "image_src" : "https://photos.zillowstatic.com/fp/a84a134c6b67e7146e61a2c05073d047-p_e.jpg",
        "price" : "$5450",
        "title" : "Realty",
        "desc" : "290 Ridgercrest Ave, Staten Island, NY-10312",
        "beds" : "5",
        "bathrooms" : "5",
        "area" : "10x3",
        "type" : "house",
        "tag" : "popular",
        "location" : "New York",
        "price_range": "$5000-$6000"
    },
    {
        "id" : "25",
        "image_src" : "https://photos.zillowstatic.com/fp/34c831b17e41ef54ed2f6745f2336c27-p_e.jpg",
        "price" : "$1240",
        "title" : "Homes R Us",
        "desc" : "564 New Dorp Ln, Staten Island, NY 10306",
        "beds" : "3",
        "bathrooms" : "2",
        "area" : "4x3",
        "type" : "house",
        "tag" : "popular",
        "location" : "New York",
        "price_range": "$1000-$2000"
    },
    {
        "id" : "26",
        "image_src" : "https://photos.zillowstatic.com/fp/f7993ddcfcaa8ca68106b95efd94bee9-p_e.jpg",
        "price" : "$560",
        "title" : "Garden Heights",
        "desc" : "35-49 83rd St #1l, Flusing, NY 10306",
        "beds" : "1",
        "bathrooms" : "1",
        "area" : "4x3",
        "type" : "flat",
        "location" : "New York",
        "price_range": "$500-$1000"
    },
    {
        "id" : "27",
        "image_src" : "https://photos.zillowstatic.com/fp/36ce96d433a90bf4feaeca6934f3ef8a-p_e.jpg",
        "price" : "$4560",
        "title" : "Calabrese",
        "desc" : "888 E 54th St, Brooklyn, NY 11234",
        "beds" : "4",
        "bathrooms" : "4",
        "area" : "6x3",
        "type" : "apartment",
        "location" : "New York",
        "price_range": "$4000-$5000"
    },
    {
        "id" : "28",
        "image_src" : "https://photos.zillowstatic.com/fp/c98567233b1937aeea3c1d4745057a2a-p_e.jpg",
        "price" : "$4239",
        "title" : "Compass",
        "desc" : "145 Reade St, Brooklyn, NY 10034",
        "beds" : "5",
        "bathrooms" : "4",
        "area" : "6x3",
        "type" : "apartment",
        "location" : "New York",
        "price_range": "$4000-$5000"
    },
    {
        "id" : "29",
        "image_src" : "https://photos.zillowstatic.com/fp/829ca93937e1a5a138f2baff3e9bf090-p_e.jpg",
        "price" : "$5490",
        "title" : "Corcoran",
        "desc" : "111 W 57th St Penthouse 72, New York",
        "beds" : "5",
        "bathrooms" : "4",
        "area" : "9x3",
        "type" : "apartment",
        "location" : "New York",
        "price_range": "$5000-$6000"
    },
    {
        "id" : "30",
        "image_src" : "https://photos.zillowstatic.com/fp/d4f3bcb439802db93d4f596cec281678-p_e.jpg",
        "price" : "$5990",
        "title" : "Sowae",
        "desc" : "50 United Nations Plz #DPH42, New York",
        "beds" : "5",
        "bathrooms" : "4",
        "area" : "9x3",
        "type" : "house",
        "tag" : "popular",
        "location" : "New York",
        "price_range": "$5000-$6000"
    },
    


]